<template>
  <div v-loading="loading">
    <div v-if="isSecurity">
      <!-- <div v-if="credit_report != ''">
        <el-button type="warning" plain @click="createReport"
          >重新生成该报告</el-button
        >
        <div>
          <span>报告编号{{ resp_order }}</span>
          <span
            >报告生成时间 : {{ timestamp | formatDate }}
          </span>
          <table border="1" class="biaoge">
            <tr>
              <th>综合评分</th>
              <th>审核建议</th>
              <th>命中风险标注</th>
              <th>押金建议</th>
              <th>分值标注说明</th>
            </tr>
            <tr>
              <th>{{ score_norm_explain }}</th>
              <th>{{ verify_recomment }}</th>
              <th>
                <div v-for="(item, index) in hit_risk_tagging" :key="index">
                  {{ item }}
                </div>
              </th>
              <th class="yanse">{{ suggest_cash }}</th>
              <th class="yanse">
                分值在[0,650]之间,得分越低，风险越高：[0,450]建议拒绝;[450,530]建议审核;[530,650]，建议通过。
              </th>
            </tr>
          </table>
        </div>
        <div>
          <span class="jiben">基本信息</span>
          <table border="0" class="biaoge">
            <tr>
              <th>姓名:{{ name }}</th>
              <th>身份证号:{{ ident_number }}</th>
            </tr>
            <tr>
              <th>手机号:{{ phone }}</th>
              <th>年龄:{{ age }}</th>
            </tr>
            <tr>
              <th>户籍:{{ ident_number_address }}</th>
              <th>号码归属地:{{ phone_address }}</th>
            </tr>
            <tr>
              <th>
                产品类别:
                <span v-if="goods_type == 0">其他</span>
                <span v-else-if="goods_type == 1">游戏电玩</span>
                <span v-else-if="goods_type == 2">娱乐影音</span>
                <span v-else-if="goods_type == 3">电脑平板</span>
                <span v-else-if="goods_type == 4">手机优选</span>
                <span v-else>无</span>
              </th>
              <th>
                新旧:
                <span v-if="status == 0">新品</span>
                <span v-else-if="status == 1">二手</span>
                <span v-else>无</span>
              </th>
            </tr>
            <tr>
              <th>总租金:{{ total_rent > 0 ? total_rent : "无" }}</th>
              <th>总期数:{{ total_periods > 0 ? total_periods : "无" }}</th>
            </tr>
            <tr>
              <th>官方价格:{{ price > 0 ? price : "无" }}</th>
              <th>性别:{{ gender }}</th>
            </tr>
          </table>
        </div>
        <div>
          <span class="jiben">身份信息核验</span>
          <table border="1" class="biaoge">
            <tr>
              <th>实名核验:</th>
              <th>运营商核验</th>
              <th>在网时长</th>
            </tr>
            <tr>
              <th>{{ identity_two_elements }}</th>
              <th>{{ network_triple_elements }}</th>
              <th>{{ time_online }}</th>
            </tr>
          </table>
        </div>

        <div>
          <span class="jiben">法院风险信息</span>
          <table border="1" class="biaoge">
            <tr>
              <th>审结日期:</th>
              <th>类型</th>
              <th>摘要说明</th>
              <th>摘要说明</th>
            </tr>
          </table>
        </div>

        <div>
          <span class="jiben">近期贷款需求</span>
          <table border="1" class="biaoge">
            <tr>
              <th>字段</th>
              <th>机构查询</th>
              <th>大型消费金融公司</th>
              <th>其他类型公司</th>
              <th>P2P平台</th>
              <th>小额贷款公司</th>
              <th>信用卡</th>
              <th>一般消费分期平台</th>
            </tr>
            <tr>
              <th>近七天</th>
              <th>{{ d7_apply_setup_time }}</th>
              <th>{{ d7_apply_setup_time_dxxfjr }}</th>
              <th>{{ d7_apply_setup_time_other }}</th>
              <th>{{ d7_apply_setup_time_p2pwd }}</th>
              <th>{{ d7_apply_setup_time_xedkgs }}</th>
              <th>{{ d7_apply_setup_time_xyk }}</th>
              <th>{{ d7_apply_setup_time_ybxffq }}</th>
            </tr>
            <tr>
              <th>近三十天</th>
              <th>{{ m1_apply_setup_time }}</th>
              <th>{{ m1_apply_setup_time_dxxfjr }}</th>
              <th>{{ m1_apply_setup_time_other }}</th>
              <th>{{ m1_apply_setup_time_p2pwd }}</th>
              <th>{{ m1_apply_setup_time_xedkgs }}</th>
              <th>{{ m1_apply_setup_time_xyk }}</th>
              <th>{{ m1_apply_setup_time_ybxffq }}</th>
            </tr>
            <tr>
              <th>近九十天</th>
              <th>{{ m3_apply_setup_time }}</th>
              <th>{{ m3_apply_setup_time_dxxfjr }}</th>
              <th>{{ m3_apply_setup_time_other }}</th>
              <th>{{ m3_apply_setup_time_p2pwd }}</th>
              <th>{{ m3_apply_setup_time_xedkgs }}</th>
              <th>{{ m3_apply_setup_time_xyk }}</th>
              <th>{{ m3_apply_setup_time_ybxffq }}</th>
            </tr>
          </table>
        </div>
        <div>
          <span class="jiben">贷款放款信息-（老版用)</span>
          <table border="1" class="biaoge">
            <tr>
              <th>消费分期类放款机构数:{{ cflenders }}</th>
              <th>近1个月放款金额:{{ lend_money1 }}</th>
              <th>近12个月放款金额:{{ lend_money12 }}</th>
              <th>近24个月放款金额:{{ lend_money24 }}</th>
            </tr>
            <tr>
              <th>近3个月放款金额:{{ lend_money3 }}</th>
              <th>近6个月放款金额:{{ lend_money6 }}</th>
              <th>近1个月放款次数:{{ lend_number1 }}</th>
              <th>近12个月放款次数:{{ lend_number12 }}</th>
            </tr>
            <tr>
              <th>近24个月放款次数:{{ lend_number24 }}</th>
              <th>近3个月放款次数:{{ lend_number3 }}</th>
              <th>近6个月放款次数:{{ lend_number6 }}</th>
              <th>最近一次放款时间:{{ lend_time }}</th>
            </tr>
            <tr>
              <th>最近一次距今天数:{{ lend_time_distance }}</th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </table>
        </div>
        <div>
          <span class="jiben">贷款放款信息-（新版）</span>
          <table border="1" class="biaoge">
            <tr>
              <th>字段</th>
              <th>最近</th>
              <th>1个月</th>
              <th>3个月</th>
              <th>6个月</th>
              <th>12个月</th>
              <th>消费分期类</th>
              <th>网络贷款类</th>
            </tr>
            <tr>
              <th>放款次数</th>
              <th>距离最近一次放款日期已有(天){{ lend_time_distance }}</th>
              <th>{{ lend_number1 }}</th>
              <th>{{ lend_number3 }}</th>
              <th>{{ lend_number6 }}</th>
              <th>{{ lend_number12 }}</th>
              <th>{{ cflenders }}</th>
              <th>{{ nllenders }}</th>
            </tr>
            <tr>
              <th>放款金额</th>
              <th>最近一次放款时间{{ lend_time }}</th>
              <th>{{ lend_money1 }}</th>
              <th>{{ lend_money3 }}</th>
              <th>{{ lend_money6 }}</th>
              <th>{{ lend_number12 }}</th>
              <th>消费分期类</th>
              <th>网络贷款类</th>
            </tr>
          </table>
        </div>

        <div>
          <span class="jiben">贷款申请信息</span>
          <table border="1" class="biaoge">
            <tr>
              <th>近12个月申请机构总数:{{ apply_mechanism_number }}</th>
              <th>近1个月申请次数:{{ apply_time1 }}</th>
              <th>近12个月申请次数:{{ apply_time12 }}</th>
              <th>近3个月申请次数:{{ apply_time3 }}</th>
            </tr>
            <tr>
              <th>近6个月申请次数:{{ apply_time6 }}</th>
              <th>
                消费分期类申请机构数:{{ consumer_apply_mechanism_number }}
              </th>
              <th>最近一次申请日期:{{ last_apply_time }}</th>
              <th>距离最近一次申请日期的天数:{{ last_apply_time_distance }}</th>
            </tr>
            <tr>
              <th>
                网络贷款类申请机构数:{{ network_loan_apply_mechanis_mnumber }}
              </th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </table>
        </div>

        <div>
          <span class="jiben">贷款还款信息</span>
          <table border="1" class="biaoge">
            <tr>
              <th>字段</th>
              <th>1个月</th>
              <th>3个月</th>
              <th>6个月</th>
              <th>12个月</th>
              <th>24个月</th>
            </tr>
            <tr>
              <th>异常次数</th>
              <th>{{ repay_fail1 }}</th>
              <th>{{ repay_fail3 }}</th>
              <th>{{ repay_fail6 }}</th>
              <th>{{ repay_fail12 }}</th>
              <th>{{ repay_fail24 }}</th>
            </tr>
            <tr>
              <th>履约次数</th>
              <th>{{ repay_succ1 }}</th>
              <th>{{ repay_succ3 }}</th>
              <th>{{ repay_succ6 }}</th>
              <th>{{ repay_succ12 }}</th>
              <th>{{ repay_succ24 }}</th>
            </tr>
            <tr>
              <th>履约金额</th>
              <th>{{ repay_money1 }}</th>
              <th>{{ repay_money3 }}</th>
              <th>{{ repay_money6 }}</th>
              <th>{{ repay_money12 }}</th>
              <th>{{ repay_money24 }}</th>
            </tr>
          </table>
        </div>

        <div>
          <span class="jiben">历史逾期记录</span>
          <span class="jiben">近6个月逾期总次数:{{ counts }}</span>
          <table border="1" class="biaoge">
            <tr>
              <th>逾期金额区间（元）</th>
              <th>逾期天数</th>
              <th>逾期时间</th>
              <th>是否结清</th>
            </tr>
          </table>

          <span>近6个月逾期机构总数:{{ overdue_mechanism_number }}</span
          ><span>近6个月逾期总金额{{ overdue_money }}</span
          ><span>近6个月逾期未结清次数:{{ uncleared_counts }}</span>
        </div>

        <div>
          <span class="jiben">关联风险检测</span>
          <table border="1" class="biaoge">
            <tr>
              <th>3个月身份证关联手机号次数:{{ m3_idcard_to_phone_time }}</th>
              <th>3个月手机号关联身份证次数:{{ m3_phone_to_idcard_time }}</th>
            </tr>
          </table>
        </div>

        <div>
          <span class="jiben">风险名单检测</span>
          <table border="1" class="biaoge">
            <tr>
              <th>
                归属地位于高风险集中地区:{{ census_register_high_risk_area }}
              </th>
              <th>信用租赁风险名单:{{ credit_rent }}</th>
              <th>车辆租赁违约名单:{{ idcard_hit_clzlwy }}</th>
              <th>犯罪通缉名单:{{ idcard_hit_fztj }}</th>
            </tr>
            <tr>
              <th>故意违章乘车名单:{{ idcard_hit_gywzcc }}</th>
              <th>通信小号库:{{ phone_hit_txxh }}</th>
              <th>虚假号码库:{{ phone_hit_xjhm }}</th>
              <th>特殊关注名单:{{ result_xd }}</th>
            </tr>
          </table>
        </div>

        <div>
          <span class="jiben">历史租赁印记</span>
          <table border="1" class="biaoge">
            <tr>
              <th>字段</th>
              <th>近7天</th>
              <th>近1个月</th>
              <th>近3个月</th>
              <th>近6个月</th>
              <th>近12个月</th>
            </tr>
            <tr>
              <th>申请租赁次数</th>
              <th>{{ d7_apply_time }}</th>
              <th>{{ m1_apply_time }}</th>
              <th>{{ m3_apply_time }}</th>
              <th>{{ m6_apply_time }}</th>
              <th>{{ m12_apply_time }}</th>
            </tr>
            <tr>
              <th>夜间申请租赁次数</th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
            <tr>
              <th>申请租赁机构数</th>
              <th>{{ d7_apply_agency_time }}</th>
              <th>{{ m1_apply_agency_time }}</th>
              <th>{{ m3_apply_agency_time }}</th>
              <th>{{ m6_apply_agency_time }}</th>
              <th>{{ m12_apply_agency_time }}</th>
            </tr>
            <tr>
              <th>夜间申请租赁机构数</th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </table>
        </div>
      </div> -->
      <div v-if="tlx_report != ''">
        <div class="baogao">风控报告已生成，请点击查看</div>
        <div class="shhengcheng">
          <el-button type="warning" plain @click="createReportGo"
            >查看该报告</el-button
          >
        </div>
      </div>
      <div v-else class="bgelse">
        <div class="tishi">提示：请生成报告后再查看该报告！</div>
        <div class="baogao">风控报告没有生成</div>
        <div class="shhengcheng">
          <el-button type="warning" plain @click="createReport"
            >生成该报告</el-button
          >
        </div>
      </div>
    </div>
    <div v-else>
      <div class="warning_info">提示：请充值！</div>
    </div>
  </div>
</template>

<script>
import FKApi from "@/api/fengkong.js";
import Table from "../../product/product/part/spec/many/Table.vue";
import isSecurity from "@/utils/isSecurity.js";
export default {
  components: { Table },
  props: ["user_id", "order_id", "credit_report", "tlx_report"],
  data() {
    return {
      isSecurity: true, // 查看消费金额是否超过充值金额
      loading: false,
      resp_order: "",
      timestamp: "",
      timestamp1: "",
      timestamp2: "",
      timestamp3: "",
      timestamp4: "",
      timestamp5: "",
      timestamp6: "",
      score_norm_explain: "",
      verify_recomment: "",
      hit_risk_tagging: "",
      suggest_cash: "",
      name: "",
      ident_number: "",
      phone: "",
      age: "",
      ident_number_address: "",
      phone_address: "",
      goods_type: "",
      status: "",
      total_rent: "",
      total_periods: "",
      price: "",
      gender: "",
      identity_two_elements: "",
      network_triple_elements: "",
      time_online: "",
      d7_apply_setup_time: "",
      d7_apply_setup_time_dxxfjr: "",
      d7_apply_setup_time_other: "",
      d7_apply_setup_time_p2pwd: "",
      d7_apply_setup_time_xedkgs: "",
      d7_apply_setup_time_xyk: "",
      d7_apply_setup_time_ybxffq: "",

      m1_apply_setup_time: "",
      m1_apply_setup_time_dxxfjr: "",
      m1_apply_setup_time_other: "",
      m1_apply_setup_time_p2pwd: "",
      m1_apply_setup_time_xedkgs: "",
      m1_apply_setup_time_xyk: "",
      m1_apply_setup_time_ybxffq: "",

      m3_apply_setup_time: "",
      m3_apply_setup_time_dxxfjr: "",
      m3_apply_setup_time_other: "",
      m3_apply_setup_time_p2pwd: "",
      m3_apply_setup_time_xedkgs: "",
      m3_apply_setup_time_xyk: "",
      m3_apply_setup_time_ybxffq: "",
      cflenders: "",
      lend_money1: "",
      lend_money12: "",
      lend_money24: "",
      lend_money3: "",
      lend_money6: "",
      lend_number1: "",
      lend_number12: "",
      lend_number24: "",
      lend_number3: "",
      lend_number6: "",
      lend_time: "",
      lend_time_distance: "",
      nllenders: "",
      apply_mechanism_number: "",
      apply_time1: "",
      apply_time12: "",
      apply_time3: "",
      apply_time6: "",
      consumer_apply_mechanism_number: "",
      last_apply_time: "",
      last_apply_time_distance: "",
      network_loan_apply_mechanis_mnumber: "",
      repay_fail1: "",
      repay_fail3: "",
      repay_fail6: "",
      repay_fail12: "",
      repay_fail24: "",
      repay_succ1: "",
      repay_succ3: "",
      repay_succ6: "",
      repay_succ12: "",
      repay_succ24: "",
      repay_money1: "",
      repay_money3: "",
      repay_money6: "",
      repay_money12: "",
      repay_money24: "",
      counts: "",
      overdue_mechanism_number: "",
      overdue_money: "",
      uncleared_counts: "",
      m3_idcard_to_phone_time: "",
      m3_phone_to_idcard_time: "",
      census_register_high_risk_area: "",
      idcard_hit_clzlwy: "",
      credit_rent: "",
      idcard_hit_fztj: "",
      idcard_hit_gywzcc: "",
      phone_hit_txxh: "",
      phone_hit_xjhm: "",
      result_xd: "",
      d7_apply_time: "",
      m1_apply_time: "",
      m3_apply_time: "",
      m6_apply_time: "",
      m12_apply_time: "",
      d7_apply_agency_time: "",
      m1_apply_agency_time: "",
      m3_apply_agency_time: "",
      m6_apply_agency_time: "",
      m12_apply_agency_time: ""
    };
  },
  beforeCreate() {
    const self = this;
    isSecurity().then(result => {
      console.log(result);
      self.isSecurity = result;
    });
  },
  created() {
    let self = this;
    console.log(self.tlx_report, "self.tlx_report");

    if (self.credit_report == "") {
      return;
    }
    let credit_report = JSON.parse(self.credit_report);
    console.log("credit_report", credit_report);
    //报告编号
    self.resp_order = credit_report.resp_order;
    //报告生成时间
    self.timestamp = credit_report.timestamp;
    //2023 02  21  11 09 28
    // self.timestamp1 = self.timestamp.slice(0, 4);
    // self.timestamp2 = self.timestamp.slice(4, 6);
    // self.timestamp3 = self.timestamp.slice(6, 8);
    // self.timestamp4 = self.timestamp.slice(8, 10);
    // self.timestamp5 = self.timestamp.slice(10, 12);
    // self.timestamp6 = self.timestamp.slice(12, 14);
    //综合评分
    self.score_norm_explain = credit_report.resp_data.score_norm_explain;
    //审核建议
    self.verify_recomment = credit_report.resp_data.verify_recomment;
    self.hit_risk_tagging = credit_report.resp_data.hit_risk_tagging;
    self.suggest_cash = credit_report.resp_data.suggest_cash;
    //姓名
    self.name = credit_report.resp_data.base_info.name;
    //身份证号
    self.ident_number = credit_report.resp_data.base_info.ident_number;
    //手机号
    self.phone = credit_report.resp_data.base_info.phone;
    //年龄
    self.age = credit_report.resp_data.base_info.age;
    //户籍
    self.ident_number_address =
      credit_report.resp_data.base_info.ident_number_address;
    //号码归属地
    self.phone_address = credit_report.resp_data.base_info.phone_address;
    //产品类别
    self.goods_type = credit_report.resp_data.base_info.goods_type;
    //新旧
    self.status = credit_report.resp_data.base_info.status;
    //总租金
    self.total_rent = credit_report.resp_data.base_info.total_rent;
    //总期数
    self.total_periods = credit_report.resp_data.base_info.total_periods;
    //官方价格
    self.price = credit_report.resp_data.base_info.price;
    //性别
    self.gender = credit_report.resp_data.base_info.gender;
    //实名核验
    if (credit_report.resp_data.ident_info_dict.identity_two_elements == "01") {
      credit_report.resp_data.ident_info_dict.identity_two_elements = "不一致";
    } else if (
      credit_report.resp_data.ident_info_dict.identity_two_elements == "02"
    ) {
      credit_report.resp_data.ident_info_dict.identity_two_elements = "一致";
    }
    self.identity_two_elements =
      credit_report.resp_data.ident_info_dict.identity_two_elements;
    //运营商核验
    if (
      credit_report.resp_data.ident_info_dict.network_triple_elements == "01"
    ) {
      credit_report.resp_data.ident_info_dict.network_triple_elements =
        "不一致";
    } else if (
      credit_report.resp_data.ident_info_dict.network_triple_elements == "02"
    ) {
      credit_report.resp_data.ident_info_dict.network_triple_elements = "一致";
    }
    self.network_triple_elements =
      credit_report.resp_data.ident_info_dict.network_triple_elements;
    //time_online上网时长
    if (credit_report.resp_data.ident_info_dict.time_online == "1") {
      credit_report.resp_data.ident_info_dict.time_online = "[0,3)";
    } else if (credit_report.resp_data.ident_info_dict.time_online == "2") {
      credit_report.resp_data.ident_info_dict.time_online = "[3,6)";
    } else if (credit_report.resp_data.ident_info_dict.time_online == "3") {
      credit_report.resp_data.ident_info_dict.time_online = "[6,12)";
    } else if (credit_report.resp_data.ident_info_dict.time_online == "4") {
      credit_report.resp_data.ident_info_dict.time_online = "[12,24)";
    } else if (credit_report.resp_data.ident_info_dict.time_online == "5") {
      credit_report.resp_data.ident_info_dict.time_online = "[24,+)";
    } else if (credit_report.resp_data.ident_info_dict.time_online == "0") {
      credit_report.resp_data.ident_info_dict.time_online = "查无此号或已注销";
    } else if (credit_report.resp_data.ident_info_dict.time_online == "-1") {
      credit_report.resp_data.ident_info_dict.time_online = "不支持该运营商";
    } else if (credit_report.resp_data.ident_info_dict.time_online == "999") {
      credit_report.resp_data.ident_info_dict.time_online =
        "手机状态异常(注:1、销号6月以上;2、携号转网;3、未放出去的号码);非本网手机号码";
    }
    self.time_online = credit_report.resp_data.ident_info_dict.time_online;
    //personal_loan_demand 近七天
    self.d7_apply_setup_time =
      credit_report.resp_data.personal_loan_demand.d7_apply_setup_time;
    self.d7_apply_setup_time_dxxfjr =
      credit_report.resp_data.personal_loan_demand.d7_apply_setup_time_dxxfjr;
    self.d7_apply_setup_time_other =
      credit_report.resp_data.personal_loan_demand.d7_apply_setup_time_other;
    self.d7_apply_setup_time_other =
      credit_report.resp_data.personal_loan_demand.d7_apply_setup_time_other;
    self.d7_apply_setup_time_p2pwd =
      credit_report.resp_data.personal_loan_demand.d7_apply_setup_time_p2pwd;
    self.d7_apply_setup_time_xedkgs =
      credit_report.resp_data.personal_loan_demand.d7_apply_setup_time_xedkgs;
    self.d7_apply_setup_time_xyk =
      credit_report.resp_data.personal_loan_demand.d7_apply_setup_time_xyk;
    self.d7_apply_setup_time_ybxffq =
      credit_report.resp_data.personal_loan_demand.d7_apply_setup_time_ybxffq;
    //personal_loan_demand 近30天
    self.m1_apply_setup_time =
      credit_report.resp_data.personal_loan_demand.m1_apply_setup_time;
    self.m1_apply_setup_time_dxxfjr =
      credit_report.resp_data.personal_loan_demand.m1_apply_setup_time_dxxfjr;
    self.m1_apply_setup_time_other =
      credit_report.resp_data.personal_loan_demand.m1_apply_setup_time_other;
    self.m1_apply_setup_time_p2pwd =
      credit_report.resp_data.personal_loan_demand.m1_apply_setup_time_p2pwd;
    self.m1_apply_setup_time_xedkgs =
      credit_report.resp_data.personal_loan_demand.m1_apply_setup_time_xedkgs;
    self.m1_apply_setup_time_xyk =
      credit_report.resp_data.personal_loan_demand.m1_apply_setup_time_xyk;
    self.m1_apply_setup_time_ybxffq =
      credit_report.resp_data.personal_loan_demand.m1_apply_setup_time_ybxffq;
    //personal_loan_demand 近90天
    self.m3_apply_setup_time =
      credit_report.resp_data.personal_loan_demand.m3_apply_setup_time;
    self.m3_apply_setup_time_dxxfjr =
      credit_report.resp_data.personal_loan_demand.m3_apply_setup_time_dxxfjr;
    self.m3_apply_setup_time_other =
      credit_report.resp_data.personal_loan_demand.m3_apply_setup_time_other;
    self.m3_apply_setup_time_p2pwd =
      credit_report.resp_data.personal_loan_demand.m3_apply_setup_time_p2pwd;
    self.m3_apply_setup_time_xedkgs =
      credit_report.resp_data.personal_loan_demand.m3_apply_setup_time_xedkgs;
    self.m3_apply_setup_time_xyk =
      credit_report.resp_data.personal_loan_demand.m3_apply_setup_time_xyk;
    self.m3_apply_setup_time_ybxffq =
      credit_report.resp_data.personal_loan_demand.m3_apply_setup_time_ybxffq;
    //消费分期类放款机构数
    self.cflenders = credit_report.resp_data.personal_loan_f.cflenders;
    //近1个月放款金额
    self.lend_money1 = credit_report.resp_data.personal_loan_f.lend_money1;
    //近12个月放款金额
    self.lend_money12 = credit_report.resp_data.personal_loan_f.lend_money12;
    //近24个月放款金额
    self.lend_money24 = credit_report.resp_data.personal_loan_f.lend_money24;
    //近3个月放款金额
    self.lend_money3 = credit_report.resp_data.personal_loan_f.lend_money3;
    //近6个月放款金额
    self.lend_money6 = credit_report.resp_data.personal_loan_f.lend_money6;
    //近1个月放款次数
    self.lend_number1 = credit_report.resp_data.personal_loan_f.lend_number1;
    //近12个月放款次数
    self.lend_number12 = credit_report.resp_data.personal_loan_f.lend_number12;
    //近24个月放款次数
    self.lend_number24 = credit_report.resp_data.personal_loan_f.lend_number24;
    //近3个月放款次数
    self.lend_number3 = credit_report.resp_data.personal_loan_f.lend_number3;
    //近6个月放款次数
    self.lend_number6 = credit_report.resp_data.personal_loan_f.lend_number6;
    //最近一次放款时间
    self.lend_time = credit_report.resp_data.personal_loan_f.lend_time;
    //最近一次距今天数
    self.lend_time_distance = credit_report.resp_data.personal_loan_f.lend_time;
    self.nllenders = credit_report.resp_data.personal_loan_f.nllenders;
    //近12个月申请机构总数
    self.apply_mechanism_number =
      credit_report.resp_data.personal_loan_s.apply_mechanism_number;
    //近1个月申请次数
    self.apply_time1 = credit_report.resp_data.personal_loan_s.apply_time1;
    //近12个月申请次数
    self.apply_time12 = credit_report.resp_data.personal_loan_s.apply_time12;
    //近3个月申请次数
    self.apply_time3 = credit_report.resp_data.personal_loan_s.apply_time3;
    //近6个月申请次数
    self.apply_time6 = credit_report.resp_data.personal_loan_s.apply_time6;
    //消费分期类申请机构数
    self.consumer_apply_mechanism_number =
      credit_report.resp_data.personal_loan_s.consumer_apply_mechanism_number;
    //最近一次申请日期
    self.last_apply_time =
      credit_report.resp_data.personal_loan_s.last_apply_time;
    //距离最近一次申请日期的天数
    self.last_apply_time_distance =
      credit_report.resp_data.personal_loan_s.last_apply_time_distance;
    //网络贷款类申请机构数
    self.network_loan_apply_mechanis_mnumber =
      credit_report.resp_data.personal_loan_s.network_loan_apply_mechanis_mnumber;
    //近1个月还款异常次数
    if (credit_report.resp_data.personal_loan_h.repay_fail1 == "") {
      credit_report.resp_data.personal_loan_h.repay_fail1 = "无";
    } else {
      credit_report.resp_data.personal_loan_h.repay_fail1 =
        credit_report.resp_data.personal_loan_h.repay_fail1;
    }
    self.repay_fail1 = credit_report.resp_data.personal_loan_h.repay_fail1;
    //近3个月还款异常次数
    if (credit_report.resp_data.personal_loan_h.repay_fail3 == "") {
      credit_report.resp_data.personal_loan_h.repay_fail3 = "无";
    } else {
      credit_report.resp_data.personal_loan_h.repay_fail3 =
        credit_report.resp_data.personal_loan_h.repay_fail3;
    }
    self.repay_fail3 = credit_report.resp_data.personal_loan_h.repay_fail3;
    //近6个月还款异常次数
    if (credit_report.resp_data.personal_loan_h.repay_fail6 == "") {
      credit_report.resp_data.personal_loan_h.repay_fail6 = "无";
    } else {
      credit_report.resp_data.personal_loan_h.repay_fail6 =
        credit_report.resp_data.personal_loan_h.repay_fail6;
    }
    self.repay_fail6 = credit_report.resp_data.personal_loan_h.repay_fail6;
    //近12个月还款异常次数
    if (credit_report.resp_data.personal_loan_h.repay_fail12 == "") {
      credit_report.resp_data.personal_loan_h.repay_fail12 = "无";
    } else {
      credit_report.resp_data.personal_loan_h.repay_fail12 =
        credit_report.resp_data.personal_loan_h.repay_fail12;
    }
    self.repay_fail12 = credit_report.resp_data.personal_loan_h.repay_fail12;
    //近24个月还款异常次数
    if (credit_report.resp_data.personal_loan_h.repay_fail24 == "") {
      credit_report.resp_data.personal_loan_h.repay_fail24 = "无";
    } else {
      credit_report.resp_data.personal_loan_h.repay_fail24 =
        credit_report.resp_data.personal_loan_h.repay_fail24;
    }
    self.repay_fail24 = credit_report.resp_data.personal_loan_h.repay_fail24;
    //int	近1个月履约次数
    if (credit_report.resp_data.personal_loan_h.repay_succ1 == "") {
      credit_report.resp_data.personal_loan_h.repay_succ1 = "无";
    } else {
      credit_report.resp_data.personal_loan_h.repay_succ1 =
        credit_report.resp_data.personal_loan_h.repay_succ1;
    }
    self.repay_succ1 = credit_report.resp_data.personal_loan_h.repay_succ1;
    //近3个月履约次数
    if (credit_report.resp_data.personal_loan_h.repay_succ3 == "") {
      credit_report.resp_data.personal_loan_h.repay_succ3 = "无";
    } else {
      credit_report.resp_data.personal_loan_h.repay_succ3 =
        credit_report.resp_data.personal_loan_h.repay_succ3;
    }
    self.repay_succ3 = credit_report.resp_data.personal_loan_h.repay_succ3;
    //近6个月履约次数
    if (credit_report.resp_data.personal_loan_h.repay_succ6 == "") {
      credit_report.resp_data.personal_loan_h.repay_succ6 = "无";
    } else {
      credit_report.resp_data.personal_loan_h.repay_succ6 =
        credit_report.resp_data.personal_loan_h.repay_succ6;
    }
    self.repay_succ6 = credit_report.resp_data.personal_loan_h.repay_succ6;
    //近12个月履约次数
    if (credit_report.resp_data.personal_loan_h.repay_succ12 == "") {
      credit_report.resp_data.personal_loan_h.repay_succ12 = "无";
    } else {
      credit_report.resp_data.personal_loan_h.repay_succ12 =
        credit_report.resp_data.personal_loan_h.repay_succ12;
    }
    self.repay_succ12 = credit_report.resp_data.personal_loan_h.repay_succ12;
    //近24个月履约次数
    if (credit_report.resp_data.personal_loan_h.repay_succ24 == "") {
      credit_report.resp_data.personal_loan_h.repay_succ24 = "无";
    } else {
      credit_report.resp_data.personal_loan_h.repay_succ24 =
        credit_report.resp_data.personal_loan_h.repay_succ24;
    }
    self.repay_succ24 = credit_report.resp_data.personal_loan_h.repay_succ24;
    //近1个月履约金额
    if (credit_report.resp_data.personal_loan_h.repay_money1 == "") {
      credit_report.resp_data.personal_loan_h.repay_money1 = "无";
    } else {
      credit_report.resp_data.personal_loan_h.repay_money1 =
        credit_report.resp_data.personal_loan_h.repay_money1;
    }
    self.repay_money1 = credit_report.resp_data.personal_loan_h.repay_money1;
    //近3个月履约金额
    if (credit_report.resp_data.personal_loan_h.repay_money3 == "") {
      credit_report.resp_data.personal_loan_h.repay_money3 = "无";
    } else {
      credit_report.resp_data.personal_loan_h.repay_money3 =
        credit_report.resp_data.personal_loan_h.repay_money3;
    }
    self.repay_money3 = credit_report.resp_data.personal_loan_h.repay_money3;
    //近6个月履约金额
    if (credit_report.resp_data.personal_loan_h.repay_money6 == "") {
      credit_report.resp_data.personal_loan_h.repay_money6 = "无";
    } else {
      credit_report.resp_data.personal_loan_h.repay_money6 =
        credit_report.resp_data.personal_loan_h.repay_money6;
    }
    self.repay_money6 = credit_report.resp_data.personal_loan_h.repay_money6;
    //近12个月履约金额
    if (credit_report.resp_data.personal_loan_h.repay_money12 == "") {
      credit_report.resp_data.personal_loan_h.repay_money12 = "无";
    } else {
      credit_report.resp_data.personal_loan_h.repay_money12 =
        credit_report.resp_data.personal_loan_h.repay_money12;
    }
    self.repay_money12 = credit_report.resp_data.personal_loan_h.repay_money12;
    //近24个月履约金额
    if (credit_report.resp_data.personal_loan_h.repay_money24 == "") {
      credit_report.resp_data.personal_loan_h.repay_money24 = "无";
    } else {
      credit_report.resp_data.personal_loan_h.repay_money24 =
        credit_report.resp_data.personal_loan_h.repay_money24;
    }
    self.repay_money24 = credit_report.resp_data.personal_loan_h.repay_money24;
    //近6个月逾期总次数
    self.counts = credit_report.resp_data.personal_overdue_history.counts;
    //int	近6个月逾期机构总数
    self.overdue_mechanism_number =
      credit_report.resp_data.personal_overdue_history.overdue_mechanism_number;
    //近6个月逾期总金额
    self.overdue_money =
      credit_report.resp_data.personal_overdue_history.overdue_money;
    //近6个月逾期未结清次数
    self.uncleared_counts =
      credit_report.resp_data.personal_overdue_history.uncleared_counts;
    //int	3个月身份证关联手机号次数
    self.m3_idcard_to_phone_time =
      credit_report.resp_data.relevance_risk_check.m3_idcard_to_phone_time;
    //3个月手机号关联身份证次数
    self.m3_phone_to_idcard_time =
      credit_report.resp_data.relevance_risk_check.m3_phone_to_idcard_time;
    //归属地位于高风险集中地区
    if (
      credit_report.resp_data.risk_list_check.census_register_high_risk_area ==
      "0"
    ) {
      credit_report.resp_data.risk_list_check.census_register_high_risk_area =
        "未命中";
    } else {
      credit_report.resp_data.risk_list_check.census_register_high_risk_area =
        "命中";
    }
    self.census_register_high_risk_area =
      credit_report.resp_data.risk_list_check.census_register_high_risk_area;
    //车辆租赁违约名单
    if (credit_report.resp_data.risk_list_check.idcard_hit_clzlwy == "0") {
      credit_report.resp_data.risk_list_check.idcard_hit_clzlwy = "未命中";
    } else {
      credit_report.resp_data.risk_list_check.idcard_hit_clzlwy = "命中";
    }
    self.idcard_hit_clzlwy =
      credit_report.resp_data.risk_list_check.idcard_hit_clzlwy;
    //信用租赁风险名单
    if (credit_report.resp_data.risk_list_check.credit_rent == "0") {
      credit_report.resp_data.risk_list_check.credit_rent = "未命中";
    } else {
      credit_report.resp_data.risk_list_check.credit_rent = "命中";
    }
    self.credit_rent = credit_report.resp_data.risk_list_check.credit_rent;
    //犯罪通缉名单
    if (credit_report.resp_data.risk_list_check.idcard_hit_fztj == "0") {
      credit_report.resp_data.risk_list_check.idcard_hit_fztj = "未命中";
    } else {
      credit_report.resp_data.risk_list_check.idcard_hit_fztj = "命中";
    }
    self.idcard_hit_fztj =
      credit_report.resp_data.risk_list_check.idcard_hit_fztj;
    //故意违章乘车名单
    if (credit_report.resp_data.risk_list_check.idcard_hit_gywzcc == "0") {
      credit_report.resp_data.risk_list_check.idcard_hit_gywzcc = "未命中";
    } else {
      credit_report.resp_data.risk_list_check.idcard_hit_gywzcc = "命中";
    }
    self.idcard_hit_gywzcc =
      credit_report.resp_data.risk_list_check.idcard_hit_gywzcc;
    //通信小号库
    if (credit_report.resp_data.risk_list_check.phone_hit_txxh == "0") {
      credit_report.resp_data.risk_list_check.phone_hit_txxh = "未命中";
    } else {
      credit_report.resp_data.risk_list_check.phone_hit_txxh = "命中";
    }
    self.phone_hit_txxh =
      credit_report.resp_data.risk_list_check.phone_hit_txxh;
    //虚假号码库
    if (credit_report.resp_data.risk_list_check.phone_hit_xjhm == "0") {
      credit_report.resp_data.risk_list_check.phone_hit_xjhm = "未命中";
    } else {
      credit_report.resp_data.risk_list_check.phone_hit_xjhm = "命中";
    }
    self.phone_hit_xjhm =
      credit_report.resp_data.risk_list_check.phone_hit_xjhm;
    //特殊关注名单
    if (credit_report.resp_data.risk_list_check.result_xd == "0") {
      credit_report.resp_data.risk_list_check.result_xd = "未命中";
    } else {
      credit_report.resp_data.risk_list_check.result_xd = "命中";
    }
    self.result_xd = credit_report.resp_data.risk_list_check.result_xd;
    //近7天申请租赁次数
    if (credit_report.resp_data.rent_history.d7_apply_time == "") {
      credit_report.resp_data.rent_history.d7_apply_time = "无";
    } else {
      credit_report.resp_data.rent_history.d7_apply_time =
        credit_report.resp_data.rent_history.d7_apply_time;
    }
    self.d7_apply_time = credit_report.resp_data.rent_history.d7_apply_time;
    //近1个月申请租赁次数
    if (credit_report.resp_data.rent_history.m1_apply_time == "") {
      credit_report.resp_data.rent_history.m1_apply_time = "无";
    } else {
      credit_report.resp_data.rent_history.m1_apply_time =
        credit_report.resp_data.rent_history.m1_apply_time;
    }
    self.m1_apply_time = credit_report.resp_data.rent_history.m1_apply_time;
    //近3个月申请租赁次数
    if (credit_report.resp_data.rent_history.m3_apply_time == "") {
      credit_report.resp_data.rent_history.m3_apply_time = "无";
    } else {
      credit_report.resp_data.rent_history.m3_apply_time =
        credit_report.resp_data.rent_history.m3_apply_time;
    }
    self.m3_apply_time = credit_report.resp_data.rent_history.m3_apply_time;
    //int	近6个月申请租赁次数
    if (credit_report.resp_data.rent_history.m6_apply_time == "") {
      credit_report.resp_data.rent_history.m6_apply_time = "无";
    } else {
      credit_report.resp_data.rent_history.m6_apply_time =
        credit_report.resp_data.rent_history.m6_apply_time;
    }
    self.m6_apply_time = credit_report.resp_data.rent_history.m6_apply_time;
    //近12个月申请租赁次数
    if (credit_report.resp_data.rent_history.m12_apply_time == "") {
      credit_report.resp_data.rent_history.m12_apply_time = "无";
    } else {
      credit_report.resp_data.rent_history.m12_apply_time =
        credit_report.resp_data.rent_history.m12_apply_time;
    }
    self.m12_apply_time = credit_report.resp_data.rent_history.m12_apply_time;
    //近7天申请租赁机构数
    if (credit_report.resp_data.rent_history.d7_apply_agency_time == "") {
      credit_report.resp_data.rent_history.d7_apply_agency_time = "无";
    } else {
      credit_report.resp_data.rent_history.d7_apply_agency_time =
        credit_report.resp_data.rent_history.d7_apply_agency_time;
    }
    self.d7_apply_agency_time =
      credit_report.resp_data.rent_history.d7_apply_agency_time;
    //近1个月申请租赁机构数
    if (credit_report.resp_data.rent_history.m1_apply_agency_time == "") {
      credit_report.resp_data.rent_history.m1_apply_agency_time = "无";
    } else {
      credit_report.resp_data.rent_history.m1_apply_agency_time =
        credit_report.resp_data.rent_history.m1_apply_agency_time;
    }
    self.m1_apply_agency_time =
      credit_report.resp_data.rent_history.m1_apply_agency_time;
    //int	近3个月申请租赁机构数
    if (credit_report.resp_data.rent_history.m3_apply_agency_time == "") {
      credit_report.resp_data.rent_history.m3_apply_agency_time = "无";
    } else {
      credit_report.resp_data.rent_history.m3_apply_agency_time =
        credit_report.resp_data.rent_history.m3_apply_agency_time;
    }
    self.m3_apply_agency_time =
      credit_report.resp_data.rent_history.m3_apply_agency_time;
    //近6个月申请租赁机构数
    if (credit_report.resp_data.rent_history.m6_apply_agency_time == "") {
      credit_report.resp_data.rent_history.m6_apply_agency_time = "无";
    } else {
      credit_report.resp_data.rent_history.m6_apply_agency_time =
        credit_report.resp_data.rent_history.m6_apply_agency_time;
    }
    self.m6_apply_agency_time =
      credit_report.resp_data.rent_history.m6_apply_agency_time;
    //近12个月申请租赁机构数
    if (credit_report.resp_data.rent_history.m12_apply_agency_time == "") {
      credit_report.resp_data.rent_history.m12_apply_agency_time = "无";
    } else {
      credit_report.resp_data.rent_history.m12_apply_agency_time =
        credit_report.resp_data.rent_history.m12_apply_agency_time;
    }
    self.m12_apply_agency_time =
      credit_report.resp_data.rent_history.m12_apply_agency_time;
  },

  filters: {
    // 过滤器
    formatDate(create_time1) {
      let date = new Date(create_time1);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s; //年月日时分秒
    }
  },

  methods: {
    // createReport: async function() {
    //   let self = this;
    //   self.loading = true;
    //   const BAI_RON = "buer";
    //   const param = { type: BAI_RON, order_id: self.order_id };
    //   const { msg: authMsg } = await FKApi.createAuthorization(param, true);
    //   this.$message.success(authMsg);
    //   FKApi.tianlangxing(
    //     {
    //       user_id: self.user_id,
    //       order_id: self.order_id
    //     },
    //     true
    //   )
    //     .then(data => {
    //       // location.reload();
    //       self.credit_report = 123;
    //       // console.log("data.", data.data.result)
    //       let credit_report = data.data.result;
    //       //报告编号
    //       self.resp_order = credit_report.resp_order;
    //       //报告生成时间
    //       self.timestamp = credit_report.timestamp;
    //       //2023 02  21  11 09 28
    //       // self.timestamp1 = self.timestamp.slice(0, 4);
    //       // self.timestamp2 = self.timestamp.slice(4, 6);
    //       // self.timestamp3 = self.timestamp.slice(6, 8);
    //       // self.timestamp4 = self.timestamp.slice(8, 10);
    //       // self.timestamp5 = self.timestamp.slice(10, 12);
    //       // self.timestamp6 = self.timestamp.slice(12, 14);
    //       //综合评分
    //       self.score_norm_explain = credit_report.resp_data.score_norm_explain;
    //       //审核建议
    //       self.verify_recomment = credit_report.resp_data.verify_recomment;
    //       self.hit_risk_tagging = credit_report.resp_data.hit_risk_tagging;
    //       self.suggest_cash = credit_report.resp_data.suggest_cash;
    //       //姓名
    //       self.name = credit_report.resp_data.base_info.name;
    //       //身份证号
    //       self.ident_number = credit_report.resp_data.base_info.ident_number;
    //       //手机号
    //       self.phone = credit_report.resp_data.base_info.phone;
    //       //年龄
    //       self.age = credit_report.resp_data.base_info.age;
    //       //户籍
    //       self.ident_number_address =
    //         credit_report.resp_data.base_info.ident_number_address;
    //       //号码归属地
    //       self.phone_address = credit_report.resp_data.base_info.phone_address;
    //       //产品类别
    //       self.goods_type = credit_report.resp_data.base_info.goods_type;
    //       //新旧
    //       self.status = credit_report.resp_data.base_info.status;
    //       //总租金
    //       self.total_rent = credit_report.resp_data.base_info.total_rent;
    //       //总期数
    //       self.total_periods = credit_report.resp_data.base_info.total_periods;
    //       //官方价格
    //       self.price = credit_report.resp_data.base_info.price;
    //       //性别
    //       self.gender = credit_report.resp_data.base_info.gender;
    //       //实名核验
    //       if (
    //         credit_report.resp_data.ident_info_dict.identity_two_elements ==
    //         "01"
    //       ) {
    //         credit_report.resp_data.ident_info_dict.identity_two_elements =
    //           "不一致";
    //       } else if (
    //         credit_report.resp_data.ident_info_dict.identity_two_elements ==
    //         "02"
    //       ) {
    //         credit_report.resp_data.ident_info_dict.identity_two_elements =
    //           "一致";
    //       }
    //       self.identity_two_elements =
    //         credit_report.resp_data.ident_info_dict.identity_two_elements;
    //       //运营商核验
    //       if (
    //         credit_report.resp_data.ident_info_dict.network_triple_elements ==
    //         "01"
    //       ) {
    //         credit_report.resp_data.ident_info_dict.network_triple_elements =
    //           "不一致";
    //       } else if (
    //         credit_report.resp_data.ident_info_dict.network_triple_elements ==
    //         "02"
    //       ) {
    //         credit_report.resp_data.ident_info_dict.network_triple_elements =
    //           "一致";
    //       }
    //       self.network_triple_elements =
    //         credit_report.resp_data.ident_info_dict.network_triple_elements;
    //       //time_online上网时长
    //       if (credit_report.resp_data.ident_info_dict.time_online == "1") {
    //         credit_report.resp_data.ident_info_dict.time_online = "[0,3)";
    //       } else if (
    //         credit_report.resp_data.ident_info_dict.time_online == "2"
    //       ) {
    //         credit_report.resp_data.ident_info_dict.time_online = "[3,6)";
    //       } else if (
    //         credit_report.resp_data.ident_info_dict.time_online == "3"
    //       ) {
    //         credit_report.resp_data.ident_info_dict.time_online = "[6,12)";
    //       } else if (
    //         credit_report.resp_data.ident_info_dict.time_online == "4"
    //       ) {
    //         credit_report.resp_data.ident_info_dict.time_online = "[12,24)";
    //       } else if (
    //         credit_report.resp_data.ident_info_dict.time_online == "5"
    //       ) {
    //         credit_report.resp_data.ident_info_dict.time_online = "[24,+)";
    //       } else if (
    //         credit_report.resp_data.ident_info_dict.time_online == "0"
    //       ) {
    //         credit_report.resp_data.ident_info_dict.time_online =
    //           "查无此号或已注销";
    //       } else if (
    //         credit_report.resp_data.ident_info_dict.time_online == "-1"
    //       ) {
    //         credit_report.resp_data.ident_info_dict.time_online =
    //           "不支持该运营商";
    //       } else if (
    //         credit_report.resp_data.ident_info_dict.time_online == "999"
    //       ) {
    //         credit_report.resp_data.ident_info_dict.time_online =
    //           "手机状态异常（注:1、销号6月以上；2、携号转网；3、未放出去的号码）；非本网手机号码";
    //       }
    //       self.time_online =
    //         credit_report.resp_data.ident_info_dict.time_online;
    //       //personal_loan_demand 近七天
    //       self.d7_apply_setup_time =
    //         credit_report.resp_data.personal_loan_demand.d7_apply_setup_time;
    //       self.d7_apply_setup_time_dxxfjr =
    //         credit_report.resp_data.personal_loan_demand.d7_apply_setup_time_dxxfjr;
    //       self.d7_apply_setup_time_other =
    //         credit_report.resp_data.personal_loan_demand.d7_apply_setup_time_other;
    //       self.d7_apply_setup_time_other =
    //         credit_report.resp_data.personal_loan_demand.d7_apply_setup_time_other;
    //       self.d7_apply_setup_time_p2pwd =
    //         credit_report.resp_data.personal_loan_demand.d7_apply_setup_time_p2pwd;
    //       self.d7_apply_setup_time_xedkgs =
    //         credit_report.resp_data.personal_loan_demand.d7_apply_setup_time_xedkgs;
    //       self.d7_apply_setup_time_xyk =
    //         credit_report.resp_data.personal_loan_demand.d7_apply_setup_time_xyk;
    //       self.d7_apply_setup_time_ybxffq =
    //         credit_report.resp_data.personal_loan_demand.d7_apply_setup_time_ybxffq;
    //       //personal_loan_demand 近30天
    //       self.m1_apply_setup_time =
    //         credit_report.resp_data.personal_loan_demand.m1_apply_setup_time;
    //       self.m1_apply_setup_time_dxxfjr =
    //         credit_report.resp_data.personal_loan_demand.m1_apply_setup_time_dxxfjr;
    //       self.m1_apply_setup_time_other =
    //         credit_report.resp_data.personal_loan_demand.m1_apply_setup_time_other;
    //       self.m1_apply_setup_time_p2pwd =
    //         credit_report.resp_data.personal_loan_demand.m1_apply_setup_time_p2pwd;
    //       self.m1_apply_setup_time_xedkgs =
    //         credit_report.resp_data.personal_loan_demand.m1_apply_setup_time_xedkgs;
    //       self.m1_apply_setup_time_xyk =
    //         credit_report.resp_data.personal_loan_demand.m1_apply_setup_time_xyk;
    //       self.m1_apply_setup_time_ybxffq =
    //         credit_report.resp_data.personal_loan_demand.m1_apply_setup_time_ybxffq;
    //       //personal_loan_demand 近90天
    //       self.m3_apply_setup_time =
    //         credit_report.resp_data.personal_loan_demand.m3_apply_setup_time;
    //       self.m3_apply_setup_time_dxxfjr =
    //         credit_report.resp_data.personal_loan_demand.m3_apply_setup_time_dxxfjr;
    //       self.m3_apply_setup_time_other =
    //         credit_report.resp_data.personal_loan_demand.m3_apply_setup_time_other;
    //       self.m3_apply_setup_time_p2pwd =
    //         credit_report.resp_data.personal_loan_demand.m3_apply_setup_time_p2pwd;
    //       self.m3_apply_setup_time_xedkgs =
    //         credit_report.resp_data.personal_loan_demand.m3_apply_setup_time_xedkgs;
    //       self.m3_apply_setup_time_xyk =
    //         credit_report.resp_data.personal_loan_demand.m3_apply_setup_time_xyk;
    //       self.m3_apply_setup_time_ybxffq =
    //         credit_report.resp_data.personal_loan_demand.m3_apply_setup_time_ybxffq;
    //       //消费分期类放款机构数
    //       self.cflenders = credit_report.resp_data.personal_loan_f.cflenders;
    //       //近1个月放款金额
    //       self.lend_money1 =
    //         credit_report.resp_data.personal_loan_f.lend_money1;
    //       //近12个月放款金额
    //       self.lend_money12 =
    //         credit_report.resp_data.personal_loan_f.lend_money12;
    //       //近24个月放款金额
    //       self.lend_money24 =
    //         credit_report.resp_data.personal_loan_f.lend_money24;
    //       //近3个月放款金额
    //       self.lend_money3 =
    //         credit_report.resp_data.personal_loan_f.lend_money3;
    //       //近6个月放款金额
    //       self.lend_money6 =
    //         credit_report.resp_data.personal_loan_f.lend_money6;
    //       //近1个月放款次数
    //       self.lend_number1 =
    //         credit_report.resp_data.personal_loan_f.lend_number1;
    //       //近12个月放款次数
    //       self.lend_number12 =
    //         credit_report.resp_data.personal_loan_f.lend_number12;
    //       //近24个月放款次数
    //       self.lend_number24 =
    //         credit_report.resp_data.personal_loan_f.lend_number24;
    //       //近3个月放款次数
    //       self.lend_number3 =
    //         credit_report.resp_data.personal_loan_f.lend_number3;
    //       //近6个月放款次数
    //       self.lend_number6 =
    //         credit_report.resp_data.personal_loan_f.lend_number6;
    //       //最近一次放款时间
    //       self.lend_time = credit_report.resp_data.personal_loan_f.lend_time;
    //       //最近一次距今天数
    //       self.lend_time_distance =
    //         credit_report.resp_data.personal_loan_f.lend_time;
    //       self.nllenders = credit_report.resp_data.personal_loan_f.nllenders;
    //       //近12个月申请机构总数
    //       self.apply_mechanism_number =
    //         credit_report.resp_data.personal_loan_s.apply_mechanism_number;
    //       //近1个月申请次数
    //       self.apply_time1 =
    //         credit_report.resp_data.personal_loan_s.apply_time1;
    //       //近12个月申请次数
    //       self.apply_time12 =
    //         credit_report.resp_data.personal_loan_s.apply_time12;
    //       //近3个月申请次数
    //       self.apply_time3 =
    //         credit_report.resp_data.personal_loan_s.apply_time3;
    //       //近6个月申请次数
    //       self.apply_time6 =
    //         credit_report.resp_data.personal_loan_s.apply_time6;
    //       //消费分期类申请机构数
    //       self.consumer_apply_mechanism_number =
    //         credit_report.resp_data.personal_loan_s.consumer_apply_mechanism_number;
    //       //最近一次申请日期
    //       self.last_apply_time =
    //         credit_report.resp_data.personal_loan_s.last_apply_time;
    //       //距离最近一次申请日期的天数
    //       self.last_apply_time_distance =
    //         credit_report.resp_data.personal_loan_s.last_apply_time_distance;
    //       //网络贷款类申请机构数
    //       self.network_loan_apply_mechanis_mnumber =
    //         credit_report.resp_data.personal_loan_s.network_loan_apply_mechanis_mnumber;
    //       //近1个月还款异常次数
    //       if (credit_report.resp_data.personal_loan_h.repay_fail1 == "") {
    //         credit_report.resp_data.personal_loan_h.repay_fail1 = "无";
    //       } else {
    //         credit_report.resp_data.personal_loan_h.repay_fail1 =
    //           credit_report.resp_data.personal_loan_h.repay_fail1;
    //       }
    //       self.repay_fail1 =
    //         credit_report.resp_data.personal_loan_h.repay_fail1;
    //       //近3个月还款异常次数
    //       if (credit_report.resp_data.personal_loan_h.repay_fail3 == "") {
    //         credit_report.resp_data.personal_loan_h.repay_fail3 = "无";
    //       } else {
    //         credit_report.resp_data.personal_loan_h.repay_fail3 =
    //           credit_report.resp_data.personal_loan_h.repay_fail3;
    //       }
    //       self.repay_fail3 =
    //         credit_report.resp_data.personal_loan_h.repay_fail3;
    //       //近6个月还款异常次数
    //       if (credit_report.resp_data.personal_loan_h.repay_fail6 == "") {
    //         credit_report.resp_data.personal_loan_h.repay_fail6 = "无";
    //       } else {
    //         credit_report.resp_data.personal_loan_h.repay_fail6 =
    //           credit_report.resp_data.personal_loan_h.repay_fail6;
    //       }
    //       self.repay_fail6 =
    //         credit_report.resp_data.personal_loan_h.repay_fail6;
    //       //近12个月还款异常次数
    //       if (credit_report.resp_data.personal_loan_h.repay_fail12 == "") {
    //         credit_report.resp_data.personal_loan_h.repay_fail12 = "无";
    //       } else {
    //         credit_report.resp_data.personal_loan_h.repay_fail12 =
    //           credit_report.resp_data.personal_loan_h.repay_fail12;
    //       }
    //       self.repay_fail12 =
    //         credit_report.resp_data.personal_loan_h.repay_fail12;
    //       //近24个月还款异常次数
    //       if (credit_report.resp_data.personal_loan_h.repay_fail24 == "") {
    //         credit_report.resp_data.personal_loan_h.repay_fail24 = "无";
    //       } else {
    //         credit_report.resp_data.personal_loan_h.repay_fail24 =
    //           credit_report.resp_data.personal_loan_h.repay_fail24;
    //       }
    //       self.repay_fail24 =
    //         credit_report.resp_data.personal_loan_h.repay_fail24;
    //       //int	近1个月履约次数
    //       if (credit_report.resp_data.personal_loan_h.repay_succ1 == "") {
    //         credit_report.resp_data.personal_loan_h.repay_succ1 = "无";
    //       } else {
    //         credit_report.resp_data.personal_loan_h.repay_succ1 =
    //           credit_report.resp_data.personal_loan_h.repay_succ1;
    //       }
    //       self.repay_succ1 =
    //         credit_report.resp_data.personal_loan_h.repay_succ1;
    //       //近3个月履约次数
    //       if (credit_report.resp_data.personal_loan_h.repay_succ3 == "") {
    //         credit_report.resp_data.personal_loan_h.repay_succ3 = "无";
    //       } else {
    //         credit_report.resp_data.personal_loan_h.repay_succ3 =
    //           credit_report.resp_data.personal_loan_h.repay_succ3;
    //       }
    //       self.repay_succ3 =
    //         credit_report.resp_data.personal_loan_h.repay_succ3;
    //       //近6个月履约次数
    //       if (credit_report.resp_data.personal_loan_h.repay_succ6 == "") {
    //         credit_report.resp_data.personal_loan_h.repay_succ6 = "无";
    //       } else {
    //         credit_report.resp_data.personal_loan_h.repay_succ6 =
    //           credit_report.resp_data.personal_loan_h.repay_succ6;
    //       }
    //       self.repay_succ6 =
    //         credit_report.resp_data.personal_loan_h.repay_succ6;
    //       //近12个月履约次数
    //       if (credit_report.resp_data.personal_loan_h.repay_succ12 == "") {
    //         credit_report.resp_data.personal_loan_h.repay_succ12 = "无";
    //       } else {
    //         credit_report.resp_data.personal_loan_h.repay_succ12 =
    //           credit_report.resp_data.personal_loan_h.repay_succ12;
    //       }
    //       self.repay_succ12 =
    //         credit_report.resp_data.personal_loan_h.repay_succ12;
    //       //近24个月履约次数
    //       if (credit_report.resp_data.personal_loan_h.repay_succ24 == "") {
    //         credit_report.resp_data.personal_loan_h.repay_succ24 = "无";
    //       } else {
    //         credit_report.resp_data.personal_loan_h.repay_succ24 =
    //           credit_report.resp_data.personal_loan_h.repay_succ24;
    //       }
    //       self.repay_succ24 =
    //         credit_report.resp_data.personal_loan_h.repay_succ24;
    //       //近1个月履约金额
    //       if (credit_report.resp_data.personal_loan_h.repay_money1 == "") {
    //         credit_report.resp_data.personal_loan_h.repay_money1 = "无";
    //       } else {
    //         credit_report.resp_data.personal_loan_h.repay_money1 =
    //           credit_report.resp_data.personal_loan_h.repay_money1;
    //       }
    //       self.repay_money1 =
    //         credit_report.resp_data.personal_loan_h.repay_money1;
    //       //近3个月履约金额
    //       if (credit_report.resp_data.personal_loan_h.repay_money3 == "") {
    //         credit_report.resp_data.personal_loan_h.repay_money3 = "无";
    //       } else {
    //         credit_report.resp_data.personal_loan_h.repay_money3 =
    //           credit_report.resp_data.personal_loan_h.repay_money3;
    //       }
    //       self.repay_money3 =
    //         credit_report.resp_data.personal_loan_h.repay_money3;
    //       //近6个月履约金额
    //       if (credit_report.resp_data.personal_loan_h.repay_money6 == "") {
    //         credit_report.resp_data.personal_loan_h.repay_money6 = "无";
    //       } else {
    //         credit_report.resp_data.personal_loan_h.repay_money6 =
    //           credit_report.resp_data.personal_loan_h.repay_money6;
    //       }
    //       self.repay_money6 =
    //         credit_report.resp_data.personal_loan_h.repay_money6;
    //       //近12个月履约金额
    //       if (credit_report.resp_data.personal_loan_h.repay_money12 == "") {
    //         credit_report.resp_data.personal_loan_h.repay_money12 = "无";
    //       } else {
    //         credit_report.resp_data.personal_loan_h.repay_money12 =
    //           credit_report.resp_data.personal_loan_h.repay_money12;
    //       }
    //       self.repay_money12 =
    //         credit_report.resp_data.personal_loan_h.repay_money12;
    //       //近24个月履约金额
    //       if (credit_report.resp_data.personal_loan_h.repay_money24 == "") {
    //         credit_report.resp_data.personal_loan_h.repay_money24 = "无";
    //       } else {
    //         credit_report.resp_data.personal_loan_h.repay_money24 =
    //           credit_report.resp_data.personal_loan_h.repay_money24;
    //       }
    //       self.repay_money24 =
    //         credit_report.resp_data.personal_loan_h.repay_money24;
    //       //近6个月逾期总次数
    //       self.counts = credit_report.resp_data.personal_overdue_history.counts;
    //       //int	近6个月逾期机构总数
    //       self.overdue_mechanism_number =
    //         credit_report.resp_data.personal_overdue_history.overdue_mechanism_number;
    //       //近6个月逾期总金额
    //       self.overdue_money =
    //         credit_report.resp_data.personal_overdue_history.overdue_money;
    //       //近6个月逾期未结清次数
    //       self.uncleared_counts =
    //         credit_report.resp_data.personal_overdue_history.uncleared_counts;
    //       //int	3个月身份证关联手机号次数
    //       self.m3_idcard_to_phone_time =
    //         credit_report.resp_data.relevance_risk_check.m3_idcard_to_phone_time;
    //       //3个月手机号关联身份证次数
    //       self.m3_phone_to_idcard_time =
    //         credit_report.resp_data.relevance_risk_check.m3_phone_to_idcard_time;
    //       //归属地位于高风险集中地区
    //       if (
    //         credit_report.resp_data.risk_list_check
    //           .census_register_high_risk_area == "0"
    //       ) {
    //         credit_report.resp_data.risk_list_check.census_register_high_risk_area =
    //           "未命中";
    //       } else {
    //         credit_report.resp_data.risk_list_check.census_register_high_risk_area =
    //           "命中";
    //       }
    //       self.census_register_high_risk_area =
    //         credit_report.resp_data.risk_list_check.census_register_high_risk_area;
    //       //车辆租赁违约名单
    //       if (
    //         credit_report.resp_data.risk_list_check.idcard_hit_clzlwy == "0"
    //       ) {
    //         credit_report.resp_data.risk_list_check.idcard_hit_clzlwy =
    //           "未命中";
    //       } else {
    //         credit_report.resp_data.risk_list_check.idcard_hit_clzlwy = "命中";
    //       }
    //       self.idcard_hit_clzlwy =
    //         credit_report.resp_data.risk_list_check.idcard_hit_clzlwy;
    //       //信用租赁风险名单
    //       if (credit_report.resp_data.risk_list_check.credit_rent == "0") {
    //         credit_report.resp_data.risk_list_check.credit_rent = "未命中";
    //       } else {
    //         credit_report.resp_data.risk_list_check.credit_rent = "命中";
    //       }
    //       self.credit_rent =
    //         credit_report.resp_data.risk_list_check.credit_rent;
    //       //犯罪通缉名单
    //       if (credit_report.resp_data.risk_list_check.idcard_hit_fztj == "0") {
    //         credit_report.resp_data.risk_list_check.idcard_hit_fztj = "未命中";
    //       } else {
    //         credit_report.resp_data.risk_list_check.idcard_hit_fztj = "命中";
    //       }
    //       self.idcard_hit_fztj =
    //         credit_report.resp_data.risk_list_check.idcard_hit_fztj;
    //       //故意违章乘车名单
    //       if (
    //         credit_report.resp_data.risk_list_check.idcard_hit_gywzcc == "0"
    //       ) {
    //         credit_report.resp_data.risk_list_check.idcard_hit_gywzcc =
    //           "未命中";
    //       } else {
    //         credit_report.resp_data.risk_list_check.idcard_hit_gywzcc = "命中";
    //       }
    //       self.idcard_hit_gywzcc =
    //         credit_report.resp_data.risk_list_check.idcard_hit_gywzcc;
    //       //通信小号库
    //       if (credit_report.resp_data.risk_list_check.phone_hit_txxh == "0") {
    //         credit_report.resp_data.risk_list_check.phone_hit_txxh = "未命中";
    //       } else {
    //         credit_report.resp_data.risk_list_check.phone_hit_txxh = "命中";
    //       }
    //       self.phone_hit_txxh =
    //         credit_report.resp_data.risk_list_check.phone_hit_txxh;
    //       //虚假号码库
    //       if (credit_report.resp_data.risk_list_check.phone_hit_xjhm == "0") {
    //         credit_report.resp_data.risk_list_check.phone_hit_xjhm = "未命中";
    //       } else {
    //         credit_report.resp_data.risk_list_check.phone_hit_xjhm = "命中";
    //       }
    //       self.phone_hit_xjhm =
    //         credit_report.resp_data.risk_list_check.phone_hit_xjhm;
    //       //特殊关注名单
    //       if (credit_report.resp_data.risk_list_check.result_xd == "0") {
    //         credit_report.resp_data.risk_list_check.result_xd = "未命中";
    //       } else {
    //         credit_report.resp_data.risk_list_check.result_xd = "命中";
    //       }
    //       self.result_xd = credit_report.resp_data.risk_list_check.result_xd;
    //       //近7天申请租赁次数
    //       if (credit_report.resp_data.rent_history.d7_apply_time == "") {
    //         credit_report.resp_data.rent_history.d7_apply_time = "无";
    //       } else {
    //         credit_report.resp_data.rent_history.d7_apply_time =
    //           credit_report.resp_data.rent_history.d7_apply_time;
    //       }
    //       self.d7_apply_time =
    //         credit_report.resp_data.rent_history.d7_apply_time;
    //       //近1个月申请租赁次数
    //       if (credit_report.resp_data.rent_history.m1_apply_time == "") {
    //         credit_report.resp_data.rent_history.m1_apply_time = "无";
    //       } else {
    //         credit_report.resp_data.rent_history.m1_apply_time =
    //           credit_report.resp_data.rent_history.m1_apply_time;
    //       }
    //       self.m1_apply_time =
    //         credit_report.resp_data.rent_history.m1_apply_time;
    //       //近3个月申请租赁次数
    //       if (credit_report.resp_data.rent_history.m3_apply_time == "") {
    //         credit_report.resp_data.rent_history.m3_apply_time = "无";
    //       } else {
    //         credit_report.resp_data.rent_history.m3_apply_time =
    //           credit_report.resp_data.rent_history.m3_apply_time;
    //       }
    //       self.m3_apply_time =
    //         credit_report.resp_data.rent_history.m3_apply_time;
    //       //int	近6个月申请租赁次数
    //       if (credit_report.resp_data.rent_history.m6_apply_time == "") {
    //         credit_report.resp_data.rent_history.m6_apply_time = "无";
    //       } else {
    //         credit_report.resp_data.rent_history.m6_apply_time =
    //           credit_report.resp_data.rent_history.m6_apply_time;
    //       }
    //       self.m6_apply_time =
    //         credit_report.resp_data.rent_history.m6_apply_time;
    //       //近12个月申请租赁次数
    //       if (credit_report.resp_data.rent_history.m12_apply_time == "") {
    //         credit_report.resp_data.rent_history.m12_apply_time = "无";
    //       } else {
    //         credit_report.resp_data.rent_history.m12_apply_time =
    //           credit_report.resp_data.rent_history.m12_apply_time;
    //       }
    //       self.m12_apply_time =
    //         credit_report.resp_data.rent_history.m12_apply_time;
    //       //近7天申请租赁机构数
    //       if (credit_report.resp_data.rent_history.d7_apply_agency_time == "") {
    //         credit_report.resp_data.rent_history.d7_apply_agency_time = "无";
    //       } else {
    //         credit_report.resp_data.rent_history.d7_apply_agency_time =
    //           credit_report.resp_data.rent_history.d7_apply_agency_time;
    //       }
    //       self.d7_apply_agency_time =
    //         credit_report.resp_data.rent_history.d7_apply_agency_time;
    //       //近1个月申请租赁机构数
    //       if (credit_report.resp_data.rent_history.m1_apply_agency_time == "") {
    //         credit_report.resp_data.rent_history.m1_apply_agency_time = "无";
    //       } else {
    //         credit_report.resp_data.rent_history.m1_apply_agency_time =
    //           credit_report.resp_data.rent_history.m1_apply_agency_time;
    //       }
    //       self.m1_apply_agency_time =
    //         credit_report.resp_data.rent_history.m1_apply_agency_time;
    //       //int	近3个月申请租赁机构数
    //       if (credit_report.resp_data.rent_history.m3_apply_agency_time == "") {
    //         credit_report.resp_data.rent_history.m3_apply_agency_time = "无";
    //       } else {
    //         credit_report.resp_data.rent_history.m3_apply_agency_time =
    //           credit_report.resp_data.rent_history.m3_apply_agency_time;
    //       }
    //       self.m3_apply_agency_time =
    //         credit_report.resp_data.rent_history.m3_apply_agency_time;
    //       //近6个月申请租赁机构数
    //       if (credit_report.resp_data.rent_history.m6_apply_agency_time == "") {
    //         credit_report.resp_data.rent_history.m6_apply_agency_time = "无";
    //       } else {
    //         credit_report.resp_data.rent_history.m6_apply_agency_time =
    //           credit_report.resp_data.rent_history.m6_apply_agency_time;
    //       }
    //       self.m6_apply_agency_time =
    //         credit_report.resp_data.rent_history.m6_apply_agency_time;
    //       //近12个月申请租赁机构数
    //       if (
    //         credit_report.resp_data.rent_history.m12_apply_agency_time == ""
    //       ) {
    //         credit_report.resp_data.rent_history.m12_apply_agency_time = "无";
    //       } else {
    //         credit_report.resp_data.rent_history.m12_apply_agency_time =
    //           credit_report.resp_data.rent_history.m12_apply_agency_time;
    //       }
    //       self.m12_apply_agency_time =
    //         credit_report.resp_data.rent_history.m12_apply_agency_time;
    //       self.$parent.getParams();
    //       self.loading = false;
    //       self.$message({
    //         message: "加载完成",
    //         type: "success"
    //       });
    //     })
    //     .catch(error => {});
    // }
    createReportGo() {
      console.log(this.tlx_report, "self.tlx_report");
      window.open(this.tlx_report);
    },
    createReport: async function() {
      let self = this;
      self.loading = true;
      const BAI_RON = "buer";
      const param = { type: BAI_RON, order_id: self.order_id };
      const { msg: authMsg } = await FKApi.createAuthorization(param, true);
      this.$message.success(authMsg);
      FKApi.tianlangxing(
        {
          user_id: self.user_id,
          order_id: self.order_id
        },
        true
      )
        .then(data => {
          console.log(data);
          setTimeout(function() {
            location.reload();
            window.location.reload();
          }, 7000);
        })
        .catch(error => {});
    }
  }
};
</script>

<style>
.biaoge {
  border-collapse: collapse;
  width: 100%;
}

.jiben {
  font-size: 20px;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.huan {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/fengkong/operation/detail4.vue